import request from '@/utils/request'
import qs from 'qs'
const proxyUrl = process.env.Communityapi;
const Community = process.env.Community;




// 发现首页
//轮播图
// export const FindBanner = (data) => {
//   return request({
//     method: 'get',
//     url:proxyUrl+'/banner/select/page',
//   })
// };

// 上传自己封面图
export const update_bag_data = (data) => {
  console.log(data);
  return request({
    methods: 'POST',
    url: Community + '/community/upload2',
    data,
  })
}

// 自己主页基本信息
export const me_user_data = (data) => {
  return request({
    method: 'POST',
    url: proxyUrl + '/circle/selectUserDetail',
    data: qs.stringify(data),

  })
}

// 别人主页基本信息
export const ta_ucenter_user = (data) => {
  return request({
    method: 'POST',
    url: proxyUrl + '/circle/selectOtherUserDetail',
    data: qs.stringify(data),

  })
}



// 自己 主页作品
export const me_works = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectUserTopic/page',
    data: qs.stringify(data),

  })
};

// 自己 主页作品 删除
export const delete_list = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/deleteTopicById',
    data: qs.stringify(data),
  })
};




//别人主页作品列表
export const ta_works = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectOtherUserTopic/page',
    data: qs.stringify(data),

  })
};

// 作品点赞 取消点赞
export const works_like = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: proxyUrl + '/circle/favorTopic',
    data: data,

  })
};

//自己主页圈子列表
export const me_circle = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectUserCircle/page',
    data: qs.stringify(data),

  })
};

//别人主页圈子列表
export const ta_circle = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectOtherUserCircle/page',
    data: qs.stringify(data)
  })
};

// 加入圈子
export const join_circle = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: proxyUrl + '/circleMember/join/circle',
    data,
  })
}

// 取消加入圈子
export const go_out_circle = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: proxyUrl + '/circleMember/cancel/circle',
    data,
  })
}


//粉丝列表  关注
export const circle_follow = (data) => {
  return request({
    method: 'POST',
    url: proxyUrl + '/circle/saveFollow',
    data: qs.stringify(data)
  })
}

//  粉丝列表 取消关注
export const circle_deleteFollow = (data) => {
  return request({
    method: 'POST',
    url: proxyUrl + '/circle/deleteFollow',
    data: qs.stringify(data)
  })
}


//别人主页粉丝列表
export const ta_selectUserFans = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectOtherUserFans/page',
    data: qs.stringify(data)
  })
};


// 自己主页的粉丝列表
export const me_selectUserFans = (data) => {
  return request({
    // headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '/circle/selectUserFans/page',
    data: qs.stringify(data)
  })
};


// 别人主页的关注列表
export const ta_follow = (data) => {
  return request({
    // headers: {'Content-Type':'application/json','Accept': 'application/json'},
    method: 'post',
    url: proxyUrl + '//circle/selectOtherUserFollow/page',
    data: qs.stringify(data)
  })
};
// 自己主页的关注列表
export const me_follow = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/circle/selectUserFollow/page',
    data: qs.stringify(data)
  })
};


// 自己主页的影展信息
export const me_photo = (data) => {
  // headers: {'Content-Type':'application/json','Accept': 'application/json'},
  return request({
    method: 'post',
    url: proxyUrl + '/photoshow/selectUserTopic/page',
    data: qs.stringify(data)
  })
};


// 创建影展
export const save_photo = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/photoshow/save',
    data,
  })
};

// 删除个人主页的影展
export const deletePhotoShow = (data) => {
  return request({
    // headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/photoshow/deletePhotoShow',
    data: qs.stringify(data)
  })
};

// 编辑个人主页的影展
export const editPhotoSave = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/photoshow/editPhotoSave',
    data,
  })
};




// 个人影展，查看详情以及修改影展作品  上传的地方
export const updatePhoto_details = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '​/photoshow/updatePhoto',
    data,
  })
};




// 影展上传 保存
export const savePhoto = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/photoshow/saveOrUpdatePhoto',
    data,
  })
};


// 删除影展作品
export const deletePhoto = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/photoshow/deletePhoto',
    data: qs.stringify(data)
  })
};


// 设置影展封面
export const setPhotoCover = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/photoshow/setPhotoCover',
    data: qs.stringify(data)
  })
};



// 他人影展列表
export const ta_PhotoShow = (data) => {
  return request({
    // headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'post',
    url: proxyUrl + '/photoshow/selectOtherUserPhotoShow',
    data: qs.stringify(data)
  })
};


// WEBPACK FOOTER //
// ./src/utils/api/ucenter.js